import React from 'react'

import {PageProvider} from '../PocketHitsShared/page-context';
import { state } from '../PocketHitsShared/state';

import Footer from '../../../syndication/Components/ArticleFooter/MockElement'
import Element from './Element'

const { csrfSymfony } = state


export default () => {
  return (
    <div>
      
      <PageProvider csrfSymfony={csrfSymfony}>
        <Element />
      </PageProvider>

      {/* footer is borrowed from syndication pages; there is currently no
      "standard" header/footer situation, so we'll just pull what we need for now */}
      <Footer />
    </div>
  );
}